import React from 'react';

/**
 * Frosted-glass fade at the top and bottom edges of the viewport.
 *
 * Inspiration: iOS Safari's bottom toolbar, Arc Mobile, and various
 * "glass morphism" UI kits — content scrolls *under* these strips,
 * blurred and progressively fading out so the floating header and
 * bottom-nav read as separate surfaces without a hard seam.
 *
 * Implementation notes:
 *   • `pointer-events: none` so taps pass through to content beneath.
 *   • `backdrop-filter: blur(…)` does the glass; a faint white gradient
 *     adds just enough luminance to keep contrast at the edge.
 *   • `mask-image` fades the blur strip toward the centre so the
 *     transition is gradient-smooth, not a cutout.
 *   • Top strip is shorter (80px) — it only needs to sit behind the
 *     header chips. Bottom strip is tall (140px) to hide the pill
 *     nav + FAB + a soft runway above them.
 */
export default function EdgeBlur() {
  return (
    <>
      {/* ── Top edge ───────────────────────────────────────────── */}
      <div
        aria-hidden="true"
        className="fixed top-0 left-0 right-0 z-40 pointer-events-none"
        style={{
          height: 96,
          WebkitBackdropFilter: 'blur(18px) saturate(1.4)',
          backdropFilter: 'blur(18px) saturate(1.4)',
          WebkitMaskImage:
            'linear-gradient(to bottom, rgba(0,0,0,1) 60%, rgba(0,0,0,0) 100%)',
          maskImage:
            'linear-gradient(to bottom, rgba(0,0,0,1) 60%, rgba(0,0,0,0) 100%)',
          background:
            'linear-gradient(to bottom, rgba(255,255,255,0.68), rgba(255,255,255,0))',
        }}
      />

      {/* ── Bottom edge ────────────────────────────────────────── */}
      <div
        aria-hidden="true"
        className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none"
        style={{
          height: 168,
          WebkitBackdropFilter: 'blur(24px) saturate(1.4)',
          backdropFilter: 'blur(24px) saturate(1.4)',
          WebkitMaskImage:
            'linear-gradient(to top, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 100%)',
          maskImage:
            'linear-gradient(to top, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 100%)',
          background:
            'linear-gradient(to top, rgba(255,255,255,0.62), rgba(255,255,255,0))',
        }}
      />
    </>
  );
}
